export default function Login() {
  return <div>Login</div>;
}
